import React, { PureComponent, Fragment } from 'react'
import styles from './index.scss'
import NextHead from 'next/head'
import Header from './Header'
import Banner from './Banner'
import CirBtn from './CirBtn'
import CreatorResource from './CreatorResource'
import Creators from './Creators'
import ExposureResource from './ExposureResource'
import Success from './Success'
import OurResource from './OurResource'
import Form from './Form'
import Consent from './Consent'

export default class LandingPage extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      isApp: props.isApp,
    }
  }
  state = {
    headRender: false,
  }

  checkHeader = () => {
    this.setState({
      headRender: true,
    })
  }
  render() {
    const { isApp } = this.props
    const title = 'PopDaily｜波波創作者計畫招募中！',
      description = '一起創造優質的內容生態圈 ',
      image = '/statics/images/creator/landingPage/OG.png'
    return (
      <Fragment>
        <NextHead>
          <title key="title">{title}</title>
          <meta key="og:title" property="og:title" content={title} />
          <meta key="og:description" property="og:description" content={description} />
          <meta key="og:image" property="og:image" content={image} />
        </NextHead>
        <div className="container" ref={(el) => (this.containerEl = el)}>
          <style jsx>{styles}</style>
          <CirBtn />

          <Header ref={(el) => (this.headerEl = el)} isApp={isApp} checkHeader={this.checkHeader} />
          <Banner />

          {this.headerEl && (
            <CreatorResource
              changeHeaderBackgroundInit={this.headerEl._changeHeaderBackgroundInit}
              changeHeaderBackgroundBlack={this.headerEl._changeHeaderBackgroundBlack}
            />
          )}
          <Success ourResourceEl={this.ourResourceEl} />
          <OurResource ref={(el) => (this.ourResourceEl = el)} />
          <ExposureResource />
          <Creators />
          <Form />
          <Consent />
        </div>
      </Fragment>
    )
  }
}
